// extracted by mini-css-extract-plugin
module.exports = {"Footer_hr":"FooterLayout_Footer_hr__28sJg","FooterApp_section":"FooterLayout_FooterApp_section__3haZW","FooterLegal_section":"FooterLayout_FooterLegal_section__3fPoJ"};